var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-form',[_c('v-btn',{staticClass:"ml-2",attrs:{"depressed":"","color":"primary"},on:{"click":_vm.onAddMoreRoom}},[_vm._v("\n   ADD MORE ROOM\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }